import {Pipe, PipeTransform} from '@angular/core';
import {Race} from "@model";

@Pipe({
  name: 'raceAscentDescentFormat'
})
export class RaceAscentDescentFormatPipe implements PipeTransform {

  transform(race: Race | undefined): string | undefined {
    return this.getRaceLength(race);
  }

  getRaceLength(race: Race | undefined): string {
    let raceAltitude: string;
    if (race?.ascent && race?.descent) {
      raceAltitude = "+" + race!.ascent + "m" + ' / ' + "-" + race!.descent + "m";
    } else if (race?.ascent && (race?.descent === undefined || race?.descent === null)) {
      raceAltitude = "+" + race?.minAltitude + "m";
    } else if (race?.descent && (race?.ascent === undefined || race?.ascent === null)) {
      raceAltitude = "-" + race?.maxAltitude + "m";
    } else {
      raceAltitude = '-';
    }
    return raceAltitude;
  }
}
